"use client";

import { VersionTagRibbon } from "modules/common/components/VersionTagRibbon";
import { MobileMenu } from "modules/common/components/navigation/MobileMenu";
import { FeedbackSurveyTrigger } from "modules/common/components/FeedbackSurveyTrigger";
import React, { useEffect, useState } from "react";

export function DrawerComponent() {
  // Defer mounting the menu (and its data hooks) until the drawer is first
  // opened; it stays mounted afterwards so reopening is instant
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    const checkbox = document.getElementById(
      "mobile-menu-drawer"
    ) as HTMLInputElement | null;
    if (!checkbox) return;
    if (checkbox.checked) {
      setHasOpened(true);
      return;
    }
    const handleChange = () => {
      if (checkbox.checked) setHasOpened(true);
    };
    checkbox.addEventListener("change", handleChange);
    return () => checkbox.removeEventListener("change", handleChange);
  }, []);

  return (
    <>
      <label
        htmlFor="mobile-menu-drawer"
        aria-label="close sidebar"
        className="drawer-overlay"
      >
        <span className="sr-only">mobile menu drawer</span>
      </label>

      <div className="bg-base-200 flex h-full w-72 grow flex-col pb-[env(safe-area-inset-bottom)] pt-16">
        <div className="flex flex-1 flex-col overflow-y-auto">
          {hasOpened && <MobileMenu />}
        </div>

        <div className="border-base-300 border-t p-2">
          <FeedbackSurveyTrigger variant="mobile" />
        </div>

        <VersionTagRibbon />
      </div>
    </>
  );
}
